import {SharedDashboardBlankslate} from '@github-ui/shared-dashboard-lists/shared/SharedDashboardBlankslate'

import type {IssuesBoardMetadata} from './board-metadata'

/**
 * What an issues board says when the search filled no column.
 *
 * The same words the issues list uses for the same response, drawn from the same helper, so
 * a reader who switches layout is told the same thing about their search rather than being
 * shown an empty grid on one surface and a reason on the other.
 */
export function IssuesBoardBlankslate({query, metadata}: {query: string; metadata: IssuesBoardMetadata}) {
  return (
    <SharedDashboardBlankslate
      dashboardType="issues"
      variant="empty"
      emptyListState={{
        dashboardType: 'issues',
        filtered: query.length > 0,
        currentPage: metadata.pageInfo?.currentPage ?? 1,
        pageCount: metadata.pageInfo?.totalPages ?? 1,
        errorMessage: metadata.error || undefined,
      }}
    />
  )
}
